import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=0d65f61f&"
import script from "./Invoice.vue?vue&type=script&lang=ts&"
export * from "./Invoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports